import * as React from "react";
import apiClients from "../../apiClients";
import * as Messages from "../../codegen/Messages";
import { parseId } from "../../helpers/idHelper";
import { useMutationCall } from "../../hooks/useMutationCall";
import {
  ADBS_START_POLL_DELAY,
  ADBS_START_POLL_INTERVAL,
  AsyncNotificationMethodKey,
  AsyncNotificationPolledResponseKey,
} from "../../models/AsyncNotificationProviders";
import { getOciRegion } from "../../utils";
import { OperationConfirmationProps } from "../OperationTypes";

export interface AdbsStartProps extends OperationConfirmationProps {
  databaseId: string | undefined;
}

const AdbsStart = (
  { location, databaseId, onExecute }: AdbsStartProps,
): JSX.Element => {
  const { invokeCall: invokeStart } = useMutationCall(
    { method: apiClients.withRegion(getOciRegion(location)).adbsDatabaseApi.startAdbsDatabase },
  );

  React.useEffect(() => {
    const { subscriptionId, resourceGroup, resourceName } = parseId(databaseId);
    const resGroup = decodeURIComponent(resourceGroup || "");
    const resName = decodeURIComponent(resourceName || "");

    const invokeOptions = {
      onSuccess: onExecute,
      notification: {
        inProgress: {
          title: Messages.notifications.inProgress.titles.startAdbs(),
          message: Messages.notifications.inProgress.messages.startAdbs(resName),
        },
        success: {
          title: Messages.notifications.success.titles.startAdbs(),
          message: Messages.notifications.success.messages.startAdbs(resName),
        },
        failure: {
          title: Messages.notifications.failure.titles.start(),
          message: Messages.notifications.failure.messages.startAdbs(resName),
        },
        asyncPolling: {
          methodKey: AsyncNotificationMethodKey.ADBS_GET,
          methodArgs: {
            subscriptionId,
            resourceGroupName: resGroup,
            databaseName: resName,
          },
          location,
          responseMethodKey: AsyncNotificationPolledResponseKey.ADBS_STARTED_CHECK,
          delay: ADBS_START_POLL_DELAY,
          interval: ADBS_START_POLL_INTERVAL,
        },
      },
    };

    invokeStart({
      subscriptionId,
      resourceGroupName: resGroup,
      databaseName: resName,
    }, invokeOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div />;
};

export const newAdbsStart = (
  props: AdbsStartProps,
): JSX.Element => (<AdbsStart {...props} />);
